export default {
    namespaced: true,

    state: {
        currency_amount_in_cents: 0,
        transaction_date: '',
        currency_id: '',
    },

    mutations: {
        setMemoData(state, data) {
            state.currency_amount_in_cents = data.currency_grand_total_in_cents;
            state.transaction_date = data.transaction_date;
            state.currency_id = data.currency_id;
        },

        reset(state) {
            state.currency_amount_in_cents = 0;
        },
    },
};
